import qs from 'query-string';

export const getQueryStringValue = (key: string, queryString = '') => {
  if (queryString == '' && typeof window !== 'undefined') {
    queryString = window.location.search;
  }
  const values = qs.parse(queryString);
  return values[key];
};
